/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import {
  DialogContent,
  Grid,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import useSWR from 'swr';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import StopIcon from '@material-ui/icons/Stop';
import { ReactComponent as SelectPhoto } from 'Assets/select-photo.svg';
import { endpoints } from 'Api';
import { DialogFooter } from './Material-reDesign';
import styles from '../index.module.css';
import '../loader.css';

const ChooseAlbum = ({ setChooseAlbumStep, albumList, gettingAlbums,
  setExistingAlbum, chooseExistingAlbum, updateAnExistingAlbum }) => {
  const [selectedAlbum, setAlbum] = useState(undefined);

  return (
    <>
      <DialogContent
        dropEffect="copy"
        className={styles.content}
        style={{ position: 'relative', overflow: 'hidden' }}
      >
        <div className={styles.actionContainer}>
          <Grid container>
            <Grid item xs={5} sm={5} className={styles.iconColumn}>
              <div className={styles.alignCenterContainer}>
                <div
                  className={styles.addFilesSectionImageContainer}
                  onClick={() => { setChooseAlbumStep(2); }}
                >
                  <SelectPhoto className={styles.addFilesSectionImage} />
                </div>
                <div
                  onClick={() => { setChooseAlbumStep(2); }}
                  className={styles.addFilesSectionButton}
                >
                  Create New Album
                </div>
              </div>
            </Grid>
            <Grid item xs={2} sm={2} className={styles.separator}>
              <div className={styles.resizeSeparator} />
            </Grid>
            <Grid item xs={5} sm={5} className={styles.iconColumn}>
              <div className={styles.alignCenterContainer}>
                <div className={styles.albumContainer}>
                  {
                    gettingAlbums ? (
                      <div className={styles.albumTitle}>Loading</div>
                    ) : (
                      <>
                        <div className={styles.albumTitle}>
                          Albums
                        </div>
                        <div className={styles.albumList}>
                          {
                            albumList?.map((album) => (
                              <>
                                <FormControlLabel
                                  control={(
                                    <Checkbox
                                      onChange={(e) => { setExistingAlbum(album.id); }}
                                      icon={<CheckBoxOutlineBlankIcon color="primary" />}
                                      checkedIcon={
                                        chooseExistingAlbum === album.id
                                          ? <StopIcon color="primary" />
                                          : <CheckBoxOutlineBlankIcon color="primary" />
                                      }
                                      name="checkedH"
                                      value={chooseExistingAlbum}
                                    />
                                  )}
                                  label={album.title}
                                />
                                {/* <div className={styles.albumTitle}>{album.title}</div> */}
                              </>
                            ))
                          }
                        </div>
                      </>
                    )
                  }
                </div>
                <div
                  disabled={!chooseExistingAlbum}
                  onClick={() => { setChooseAlbumStep(2); updateAnExistingAlbum(true); }}
                  className={styles.addFilesSectionButton}
                >
                  Add To Existing Album
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </DialogContent>
      <DialogFooter>
        <div className={styles.uploadTerms}>
          By submitting your videos to Projector,
          you acknowledge that you agree to Projector’s Terms of Service and Community Guidelines.
          Please make sure that you do not violate others’ copyright or privacy rights. Learn more
        </div>
      </DialogFooter>
    </>
  );
};

export default ChooseAlbum;
